export default __webpack_public_path__ + "static/media/repro_presencial.ed099d0f.svg";